
import { defineComponent, PropType } from 'vue'
import { Index, User } from "../../types";
import IndexList from './IndexList.vue'

interface Data {
  selectedUser?: User;
}

export default defineComponent({
  name: 'UserStrategyList',
  components: {
    IndexList
  },
  props: {
    list: {
      type: Array as PropType<Index[]>
    },
    users: {
      type: Array as PropType<User[]>
    },
  },
  emits: ['selectUser'],
  data () {
    return {
      selectedUser: undefined,
    } as Data
  },

  methods: {
    selectUser (user: User) {
      if (this.selectedUser === user) {
        this.selectedUser = undefined
      } else {
        this.selectedUser = user
        this.$emit('selectUser', user)
      }
    },
  },

})
